import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=6780039a"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6780039a')) {
      api.createRecord('6780039a', component.options)
    } else {
      api.reload('6780039a', component.options)
    }
    module.hot.accept("./OtpInput.vue?vue&type=template&id=6780039a", function () {
      api.rerender('6780039a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/OtpInput.vue"
export default component.exports